import { createContext, useContext, useState } from "react";

const PostsContext = createContext();

export function PostsProvider({ children }) {
  const [posts] = useState([
    {
      id: 1,
      titulo: "Camisa Azul",
      categoria: "Roupas",
      tipo: "Venda",
      preco: "R$ 50",
      foto: "https://placehold.co/300x300?text=Camisa+Azul&bg=0000FF&fg=FFFFFF",
      status: "Disponível",
      descricao: "Camisa azul de algodão, tamanho M, em ótimo estado.",
      caracteristicas: ["Tamanho M", "Algodão", "Pouco uso"],
    },
    {
      id: 2,
      titulo: "Sapatos Pretos",
      categoria: "Calçados",
      tipo: "Doação",
      preco: "",
      foto: "https://placehold.co/300x300?text=Sapatos+Pretos&bg=000000&fg=FFFFFF",
      status: "Disponível",
      descricao: "Sapatos pretos sociais, número 42.",
      caracteristicas: ["Número 42", "Couro sintético"],
    },
    {
      id: 3,
      titulo: "Bolsa Vermelha",
      categoria: "Acessórios",
      tipo: "Venda",
      preco: "R$ 80",
      foto: "https://placehold.co/300x300?text=Bolsa+Vermelha&bg=FF0000&fg=FFFFFF",
      status: "Indisponível",
      descricao: "Bolsa feminina vermelha, pouco usada.",
      caracteristicas: ["Couro", "Alça regulável"],
    },
  ]);

  return (
    <PostsContext.Provider value={{ posts }}>
      {children}
    </PostsContext.Provider>
  );
}

export function usePosts() {
  return useContext(PostsContext);
}
